import { htmlUrls } from '@shared/utils/router-paths';
import { Router, RouterOutlet } from '@angular/router';
import { LocalRepository } from '@shared/helper/local-repository';
import { BaseComponent } from '@shared/components/base/base.component';
import { Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { HeaderActionListGeneratorService } from '@shared/helper/services/header-action-list-generator.service';
import { SharedModule } from '@shared/module/shared.module';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';
import { setTheme } from './theme/themeing';
import { delay, filter, switchMap, take, takeUntil, tap } from 'rxjs';
import { ShareContentService } from '@shared/components/dialogs/share-preview-dialog/service/share-content.service';
import { MatDialog } from '@angular/material/dialog';
import { ShareContainerDialogComponent } from '@shared/components/dialogs/share-preview-dialog/share-container-dialog/share-container-dialog.component';
import { routeTransition } from './route-transitions';
import { BadgeNotifierService } from '@shared/service/other_services/badge-notifier.service';

declare let Goftino: any;
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SharedModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
  ],
  animations: [routeTransition],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {
  private _router = inject(Router);
  private _localRepository = inject(LocalRepository);
  private _headerActionListGeneratorService = inject(HeaderActionListGeneratorService);
  private imagePipe = inject(ImagePipe);
  private shareContentService = inject(ShareContentService);
  dialog = inject(MatDialog);
  private badgeNotifierService = inject(BadgeNotifierService);


  ngOnInit() {
    // ? Generate header action list
    this._headerActionListGeneratorService.generate();
    if (this._localRepository.IsInBrowser) {
      this.handleGoftino();
      this.appStateService.theme.pipe(takeUntil(this.unsubscribe$)).subscribe(() => setTheme(this._localRepository));
    }
    this.openSharedContentDialog().pipe(takeUntil(this.unsubscribe$)).subscribe();
    this.openUnseenBadgePopup().subscribe();
  }

  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event: any): void {
    if (
      event?.target?.classList[0] == "mention-link" &&
      event?.target?.innerText?.includes("@")
    ) {
      if (event?.target?.innerText == undefined) return;
      const userName = event.target.innerText.slice(1).trim();
      if (userName) {
        this._router.navigate([htmlUrls.profile, userName]);
      }
    }
  }

  handleGoftino() {
    window.addEventListener('goftino_ready', () => {
      this.setUserIdInGoftino();
      this.setUserInGoftino();
    });
  }

  setUserInGoftino() {
    if (this.currentUser?.id) {
      Goftino.setUser({
        email: this.currentUser.email,
        name: this.currentUser?.firstName + `(${this.currentUser?.uniqeName})`,
        phone: this.currentUser?.phoneNumber,
        tags: this.currentUser?.roleNames,
        avatar: this.imagePipe.transform(this.currentUser?.id, EImageType.userAvatar, this.currentUser.hasPhoto),
        forceUpdate: true
      });
    }

  }

  setUserIdInGoftino() {
    if (this.currentUser?.id) {
      Goftino.setUserId(this.currentUser?.id);
    }

  }

  openSharedContentDialog() {
    return this.shareContentService.sharedContent.pipe(
      filter(res => !!res),
      tap(res => {
        this.dialog.open(ShareContainerDialogComponent, {
          panelClass: 'share-dialog',
          data: res
        })

      })
    )
  }

  // @HostListener('window:beforeunload', [])
  // handleBeforeUnload() {
  //   if (this.isFirefox!) {
  //     const overlays = document.querySelectorAll('.cdk-overlay-container');
  //     overlays.forEach((overlay) => overlay.remove());

  //   }
  // }

  // // Reload the page if Safari loads it from cache
  // @HostListener('window:pageshow', ['$event'])
  // onPageShow(event: PageTransitionEvent) {
  //   if (event.persisted && this.Repository.IsInBrowser) {
  //     window.location.reload();
  //   }
  // }

  // private isFirefox(): boolean {
  //   return navigator.userAgent.toLowerCase().includes('firefox');
  // }

  openUnseenBadgePopup() {
    return this.badgeNotifierService.badgeNotifire$.pipe(
      delay(5000),
      take(1),
      switchMap(() => this.badgeNotifierService.checkForBadge())
    );
  }

}

